export default [
    {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
        is_admin: [1, 2, 3, 4],
    },
    {
        title: 'Cadastros',
        icon: 'TagIcon',
        is_admin: [1, 2, 4],
        children: [
            {
                title: 'Usuários',
                route: 'list-users',
                is_admin: [1, 2, 4],
            },
            {
                title: 'Departamentos',
                route: 'list-departments',
                is_admin: [1, 2, 3],
            },
            {
                title: 'Cargos',
                route: 'list-roles',
                is_admin: [1, 2, 3],
            },
            {
                title: 'Jornadas',
                route: 'list-journey',
                is_admin: [1, 2, 3],
            },
            {
                title: 'Feriados',
                route: 'list-feriados',
                is_admin: [1, 2, 3],
            },
            {
                title: 'Empresas',
                route: 'list-companies',
                is_admin: [1, 2],
            },
            {
                title: 'Alocação',
                route: 'list-alocations',
                is_admin: [1, 2],
            },
            {
                title: 'Requisitos',
                route: 'list-requirements',
                is_admin: [1, 2],
            },
            // {
            //     title: 'Violações de Cerca',
            //     route: 'geofences-violations',
            //     is_admin: [1, 2],
            // },
        ],
    },
    {
        title: 'Gerenciamento',
        icon: 'SettingsIcon',
        is_admin: [1, 2, 3, 4],
        children: [
            {
                title: 'Férias',
                route: 'list-vacations',
                is_admin: [1, 2],
            },
            {
                title: 'Fechar Espelhos',
                route: 'close-point-mirror',
                is_admin: [1, 2],
            },
            {
                title: 'Consultar Espelhos',
                route: 'consult-point-mirror',
                is_admin: [1, 2, 4],
            },
            {
                title: 'Horas Adicionais',
                route: 'list-aditional-hours',
                is_admin: [1, 2],
            },
            {
                title: 'Solicitações de Marcação',
                route: 'list-check-request',
                is_admin: [1, 2, 3, 4],
            },
            {
                title: 'Solicitação de Cancelamento de Troca',
                route: 'Solicitação de Cancelamento de Troca',
                is_admin: [1, 2, 3, 4],
            },
            {
                title: 'Solicitações de Vale-Transporte',
                route: 'list-solicitation_vt',
                is_admin: [1, 2],
            },
            {
                title: 'Marcar Manualmente',
                route: 'Pontos Manuais',
                is_admin: [1, 2, 4],
            },
            {
                title: 'Escala de Trabalho',
                route: 'Lista Escala de Trabalho',
                is_admin: [1, 2, 3, 4],
            },
            {
                title: 'Plantões',
                route: 'Plantões',
                is_admin: [1, 2, 4],
            },
            {
                title: 'Ajustes de Marcação',
                route: 'list-check-adjustment-requests',
                is_admin: [1, 2, 4],
            },
            {
                title: 'Aprovações de Ponto',
                route: 'approvals-check-schedule-deviations',
                is_admin: [1, 2, 4],
            },
            {
                title: 'Desvios de Jornada',
                route: 'list-check-schedule-deviations',
                is_admin: [1, 2, 4],
            },
        ],
    },
    {
        title: 'Exportação',
        icon: 'FileTextIcon',
        is_admin: [1, 2, 4],
        children: [
            {
                title: 'Exportação de Marcação',
                route: 'list-check-export',
                is_admin: [1, 2, 4],
            },
        ],
    },
    {
        title: 'Importação',
        icon: 'UploadIcon',
        is_admin: [1, 2, 4],
        children: [
            {
                title: 'Importação de Usuários',
                route: 'import-users',
                is_admin: [1, 2, 4],
            },
            {
                title: 'Importar J4 (SAMU)',
                route: 'importar-j4',
                is_admin: [1, 2],
            },
            {
                title: 'Importar J4 (TIH)',
                route: 'importar-j4-tih',
                is_admin: [1, 2],
            },
            {
                title: 'Importar Endereços de Base',
                route: 'base-address-import',
                is_admin: [1, 2],
            },
            {
                title: 'Importar Férias',
                route: 'vacation-import',
                is_admin: [1, 2],
            },
        ],
    },
    {
        title: 'Marcações',
        route: 'Pontos da equipe',
        icon: 'UsersIcon',
        is_admin: [1, 2, 4],
    },
    {
        title: 'Relógio de Ponto',
        route: 'Marcar ponto',
        icon: 'GridIcon',
        is_admin: [1, 2, 4],
    },
    {
        title: 'Meus Espelhos de Ponto',
        route: 'Meus espelhos de ponto',
        icon: 'FileTextIcon',
        is_admin: [1, 2, 3, 4],
    },
    {
        title: 'Meu Ponto',
        route: 'Meus pontos',
        icon: 'ClockIcon',
        is_admin: [1, 2, 3, 4],
    },
    {
        title: 'Verificar Ponto',
        route: 'Verificar ponto por token',
        icon: 'CheckCircleIcon',
        is_admin: [1, 2, 3, 4],
    },
    // {
    //   title: 'Ponto',
    //   route: 'Marcar Ponto',
    //   icon: 'TagIcon',
    //   is_admin: [1, 2, 3],
    // },
    // {
    //   title: 'Solicitar Marcação',
    //   route: 'Solicitação de marcação',
    //   icon: 'ClockIcon',
    //   is_admin: [1, 2, 3],
    // },
    {
        title: 'Auditoria',
        icon: 'ShieldIcon',
        is_admin: [1],
        children: [
            {
                title: 'Logs de Atividade',
                route: 'list-activity-logs',
                is_admin: [1],
            },
            {
                title: 'Batidas Excluídas',
                route: 'list-checks-trashed',
                is_admin: [1],
            },
        ],
    },
    {
        title: 'Consulta',
        icon: 'SearchIcon',
        is_admin: [1, 2, 4],
        children: [
            {
                title: 'CPF',
                route: 'lookup',
                is_admin: [1, 2, 4],
            },
            // {
            //     title: 'Ativos',
            //     route: 'lookup-add',
            //     is_admin: [1, 2, 4],
            // },
        ],
    },
    {
        title: 'Configurações',
        route: 'Configuration',
        icon: 'SettingsIcon',
        is_admin: [1, 2],
    },

]
